module.exports = __webpack_public_path__ + "img/guding.43732307.png";